import { make } from 'vuex-pathify';


const namespaced = true;
const state = {
    expiryDate: '',
    lastFourDigit: '',
    legalId: '',
    mobileNumber: '',
};
const getters = { ...make.getters(state) };
const actions = { ...make.actions(state) };
const mutations = { ...make.mutations(state) };

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};